import script from "./ToolLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolLogo.vue?vue&type=script&setup=true&lang=js"

import "./ToolLogo.vue?vue&type=style&index=0&id=69455c5b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69455c5b"]])

export default __exports__